/* eslint-disable @next/next/no-img-element */
import { FC } from 'react';

import { AvatarWrapper } from './styles';
import logo from '../../../../../public/images/logo-header.png';

export const Avatar: FC = () => {
  return (
    <AvatarWrapper>
      <img
        src={logo.src}
        alt="avatar"
        style={{
          borderRadius: '50%',
          objectFit: 'contain',
          width: '40px',
          height: '40px',
        }}
      />
    </AvatarWrapper>
  );
};
